/**
 * @generated SignedSource<<bb44e323ff3f8f0284846689855a2658>>
 * @relayHash 6ae9dc394cd02b8b3c1c73797bb0d0d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1d6503b832c25eeca2fc1a49b2c9e71e944215e26316fbffd01ff1cae50bcc70

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RuleListOldHydrateJqlQuery$variables = {
  cloudId: string;
  jql: string;
};
export type RuleListOldHydrateJqlQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"fieldValueData_businessConditionalFormattingSidebar">;
      };
    } | null | undefined;
  };
};
export type RuleListOldHydrateJqlQuery = {
  response: RuleListOldHydrateJqlQuery$data;
  variables: RuleListOldHydrateJqlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "jql"
  }
],
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RuleListOldHydrateJqlQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v3/*: any*/),
                    "kind": "LinkedField",
                    "name": "hydrateJqlQuery",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "fieldValueData_businessConditionalFormattingSidebar"
                          }
                        ],
                        "type": "JiraJqlHydratedQuery"
                      },
                      (v4/*: any*/)
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jqlBuilder.hydrateJqlQuery"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RuleListOldHydrateJqlQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "hydrateJqlQuery",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraJqlField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v7/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlUserFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraPriority",
                                                "kind": "LinkedField",
                                                "name": "priority",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "priorityId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlPriorityFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprint",
                                                "kind": "LinkedField",
                                                "name": "sprint",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "sprintId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlSprintFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraGroup",
                                                "kind": "LinkedField",
                                                "name": "group",
                                                "plural": false,
                                                "selections": (v9/*: any*/)
                                              }
                                            ],
                                            "type": "JiraJqlGroupFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "statusId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlStatusFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlProjectFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "issueTypeId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlIssueTypeFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "version",
                                                "plural": false,
                                                "selections": (v9/*: any*/)
                                              }
                                            ],
                                            "type": "JiraJqlVersionFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponent",
                                                "kind": "LinkedField",
                                                "name": "component",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "componentId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlComponentFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "option",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "optionId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlOptionFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraJqlQueryHydratedValue"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlHydratedQuery"
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1d6503b832c25eeca2fc1a49b2c9e71e944215e26316fbffd01ff1cae50bcc70",
    "metadata": {},
    "name": "RuleListOldHydrateJqlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "51794bdac77a1ffb88e66089d4034692";

export default node;
